module.exports = __webpack_public_path__ + "static/media/MarkPro.bb34ddff.woff";